import { DatePicker } from "@/components/ui/date-picker";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useT } from "@/lib/i18n/use-t";
import type { IdMode } from "../trapets-lookup-widget";
import { T } from "./identifier-fields.i18n";

/**
 * QL-c — the identifier picker: which of the two a person is screened by, and
 * its value. Used for the Person client and for every representative.
 */
export function IdentifierFields({
  idPrefix,
  mode,
  setMode,
  ssn,
  setSSN,
  birthDate,
  setBirthDate,
  country,
  disabled,
}: {
  idPrefix: string;
  mode: IdMode;
  setMode: (value: IdMode) => void;
  ssn: string;
  setSSN: (value: string) => void;
  birthDate: string;
  setBirthDate: (value: string) => void;
  country: string;
  disabled: boolean;
}) {
  const t = useT(T);
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-idmode`}>
          {t.identifyBy} <span className="text-destructive">*</span>
        </Label>
        <Select value={mode} onValueChange={(v) => setMode(v as IdMode)} disabled={disabled}>
          <SelectTrigger id={`${idPrefix}-idmode`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ssn">{t.ssnNationalId}</SelectItem>
            <SelectItem value="dob">{t.dateOfBirth}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-idvalue`}>
          {mode === "ssn" ? t.ssnNationalId : t.dateOfBirth}{" "}
          <span className="text-destructive">*</span>
        </Label>
        {mode === "ssn" ? (
          <Input
            id={`${idPrefix}-idvalue`}
            value={ssn}
            onChange={(e) => setSSN(e.target.value)}
            placeholder={t.ssnPlaceholder}
            disabled={disabled}
          />
        ) : (
          <DatePicker id={`${idPrefix}-idvalue`} value={birthDate} onChange={setBirthDate} />
        )}
        <p className="text-xs text-muted-foreground">
          {t.willSearchAs}: {(mode === "ssn" ? ssn : birthDate) || "..."} ({country})
        </p>
      </div>
    </>
  );
}
